import React, { useState } from 'react';
import ImageList from './quick_img_list';
import MainImage from './quick_main_img';
import './index.less';

interface IQuickProductImage {
  product: DetailTypes.Product;
}

interface mediaItem {
  type: string;
  [key: string]: any;
}

const FILTER_TYPE = ['lightCustomModel', 'customModel', 'customHome', 'live', 'video'];
export default function ProductImage({ product }: IQuickProductImage) {
  const { productId } = product;
  const [activeId, setActiveId] = useState(0);
  //逻辑变更，需要更改mediaItems数据
  let { mediaItems } = product;

  if (!mediaItems) return null;
  //mediaItems过滤在线定制、直播、视频
  mediaItems = mediaItems.filter((item: mediaItem) => !FILTER_TYPE.includes(item.type));

  return (
    <div className="detail-quick-product-image">
      <ImageList activeId={activeId} setActiveId={setActiveId} mediaItems={mediaItems} />
      <MainImage
        setActiveId={setActiveId}
        productId={productId}
        activeId={activeId}
        mediaItems={mediaItems}
      />
    </div>
  );
}
